export default __webpack_public_path__ + "static/product1-a0735ba5183029aa78270e72e1e65acd.jpg";